;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.order.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
/*    var showState = {
      name: 'order.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        order: ['$stateParams', 'OrderManager', function ($stateParams, OrderManager) {
          return OrderManager.findById($stateParams.id, OrderManager.query({
            populate: JSON.stringify([
              { path: 'client' },
              { path: 'tags' },
              { path: 'referers' },
              { path: 'currentInvoice' },
              { path: 'bpu', populate: [{ path: 'client'}]},
              {
                path: 'invoices',
                populate: [
                  { path: 'client' },
                  { path: 'tags' },
                  { path: 'referers' }
                ]
              }
            ])
          })
          )
        }],
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getOrderPrefs().then(function (prefs) {
            return prefs.numberFormat
          })
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(
            CustomFieldManager
            .query()
            .select('invoice', 'model')).then(function (data) {
              return data.data
            }
          )
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/order/show/templates/order-show.template.html',
          controller: 'OrderShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/order/show/templates/order-show-toolbar.template.html',
          controller: 'OrderShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: "{{toolbar.status === 'draft' ? toolbar.title : toolbar.number | truncate: 50}}" + "{{toolbar.status === 'draft' ? ' (Brouillon)' : ''}}",
        parent: 'order.list'
      }
    }

    var newState = {
      name: 'order.new',
      url: '/new',
      resolve: {
        order: ['OrderService',
          function (OrderService) {
            return OrderService.createOrderFromPreferences()
          }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(
            CustomFieldManager
            .query()
            .select('order', 'model')).then(function (data) {
              return data.data
            }
          )
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/order/show/templates/order-show.template.html',
          controller: 'OrderShowController',
          controllerAs: 'show'
        }
      },
      ncyBreadcrumb: {
        label: "Création d'un chantier",
        parent: 'order.list'
      }
    }

    $stateProvider
      .state(showState)
      .state(newState)*/
  }
})(window.angular, window._, window.moment)
